import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { BrandWriteRequest } from '@/api/handlers/resources/brands/requests';
import type { BrandWriteResponse } from '@/api/handlers/resources/brands/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { BrandQueryKeys } from './brandQueryKeys';

export type UpdateBrandVariables = {
    id: string;
    body: BrandWriteRequest;
};

export const useUpdateBrandMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<BrandWriteResponse>,
        Error,
        UpdateBrandVariables
    >({
        mutationFn: ({ id, body }) => apiClient.brands.updateBrand(id, body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: BrandQueryKeys.all,
                });
            }
        },
    });
};
